import { render, staticRenderFns } from "./PromotionEditPosFree.vue?vue&type=template&id=57f982d4&scoped=true&"
import script from "./PromotionEditPosFree.vue?vue&type=script&lang=js&"
export * from "./PromotionEditPosFree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f982d4",
  null
  
)

export default component.exports